import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { InstituteCardSkeleton } from '../../../../components/institute-card/InstituteCardSkeleton';

export const FeaturedInstitutesSkeleton: React.FC = () => {
  return (
    <Box className="container-fluid" sx={{ my: 5, pt: 7.5 }}>
      <Box sx={{ mb: 5 }}>
        <Skeleton variant="rectangular" width="7.5rem" height="3rem" />
        <Skeleton sx={{ mt: 1 }} variant="rectangular" width="12.5rem" height="3rem" />
      </Box>
      <Grid sx={{ overflow: 'hidden' }} container wrap="nowrap" spacing={2.5}>
        {_.times(4).map((_item, index) => (
          <Grid item xs={12} key={index} flexShrink={0} sm={6} lg={4} xl={3}>
            <InstituteCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
